/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".success-wrap[_ngcontent-%COMP%]{text-align:left;word-break:break-word;white-space:normal}.success-wrap[_ngcontent-%COMP%]   .success-icon[_ngcontent-%COMP%]{color:green;vertical-align:middle;margin-right:5px}"];
export { styles as styles };



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/common/components/success.wrap/success.wrap.component.scss.shim.ngstyle.js.pre-build-optimizer.js